(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/models/match.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/models/match.js');

'use strict';

svs.maltipset.models.Match = Backbone.Model.extend({
  initialize: function() {
    this.setSportInLeague();
    this.setTioTidningar();
  },
  markChanged: function(mark) {
    var markedMatches = this.get('matchesMarked');
    if (mark) {
      markedMatches++;
    } else if (markedMatches > 0) {
      markedMatches--;
    }
    this.set('matchesMarked', markedMatches);
  },
  defaults: function() {
    return {
      matchesMarked: 0
    };
  },
  setSportInLeague: function() {
    var match = this.get('match');

    if (match) {
      match.league = match.league || {};
      match.league.sport = match.league.sport || {};

      if (_.isUndefined(match.league.sport.id)) {
        match.league.sport.id = 1000002;
        match.league.sport.type = svs.components.sport.sportTypes.SportTypes.Soccer;
        match.league.sport.name = 'Fotboll';
      }
    }
  },

  getTeamIds: function() {
    var match = this.get('match');
    if (match) {
      var participants = match.participants;
      return { homeTeamId: participants[0].id, awayTeamId: participants[1].id };
    }

    return {};
  },

  setTioTidningar: function() {
    var tioTidningar =
        this.get('tioTidningar') || this.get('tioTidningarsTips');
    this.set('tioTidningar', tioTidningar, { silent: true });
  }
});


 })(window);